import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/* eslint-disable */
var NullLogger = /*#__PURE__*/function () {
  function NullLogger() {
    _classCallCheck(this, NullLogger);

    this.ERROR_MESSAGE = 'NullLogger does not support. Instantiate a valid logger using "setGlobalLogger"';
    this.src = true;
  }

  _createClass(NullLogger, [{
    key: "addStream",
    value: function addStream(_stream) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "addSerializers",
    value: function addSerializers(_serializers) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "child",
    value: function child(_options, _simple) {
      return this;
    }
  }, {
    key: "reopenFileStreams",
    value: function reopenFileStreams() {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "level",
    value: function level(_value) {
      return;
    }
  }, {
    key: "levels",
    value: function levels(_name, _value) {
      return;
    }
  }, {
    key: "trace",
    value: function trace() {
      return true;
    }
  }, {
    key: "debug",
    value: function debug() {
      return true;
    }
  }, {
    key: "info",
    value: function info() {
      return true;
    }
  }, {
    key: "warn",
    value: function warn() {
      return true;
    }
  }, {
    key: "error",
    value: function error() {
      return true;
    }
  }, {
    key: "fatal",
    value: function fatal() {
      return true;
    }
  }, {
    key: "addListener",
    value: function addListener(_event, _listener) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "on",
    value: function on(_event, _listener) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "once",
    value: function once(_event, _listener) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "removeListener",
    value: function removeListener(_event, _listener) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "off",
    value: function off(_event, _listener) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(_event) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "setMaxListeners",
    value: function setMaxListeners(_n) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "getMaxListeners",
    value: function getMaxListeners() {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "listeners",
    value: function listeners(_event) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "rawListeners",
    value: function rawListeners(_event) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "emit",
    value: function emit(_event) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "listenerCount",
    value: function listenerCount(_event) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "prependListener",
    value: function prependListener(_event, _listener) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "prependOnceListener",
    value: function prependOnceListener(_event, _listener) {
      throw new Error(this.ERROR_MESSAGE);
    }
  }, {
    key: "eventNames",
    value: function eventNames() {
      throw new Error(this.ERROR_MESSAGE);
    }
  }]);

  return NullLogger;
}();

export var log = new NullLogger();
export var setGlobalLogger = function setGlobalLogger(_log) {
  log = _log;
};